module.exports = __webpack_public_path__ + "static/media/thermometer-2.18687348.svg";